import apiHelper from '../helper/ApiHelper';

const ProfileService = {
  async getProfile() {
    try {
      return await apiHelper('/profile');
    } catch (error) {
      console.error('Error fetching profile:', error);
      throw error;
    }
  },

  async updateProfile(profileId, head) {
    try {
      return await apiHelper(`/profile/${profileId}`, 'PUT', head);
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  },

  async getFinancialYears() {
    try {
      return await apiHelper('/profile/financial-listing');
    } catch (error) {
      console.error('Error fetching financial years:', error);
      throw error;
    }
  },

  async updateFinancialYear(profileId, financialYearData) {
    try {
      return await apiHelper(`/profile/financial-year/${profileId}`, 'PUT', financialYearData);
    } catch (error) {
      console.error('Error updating financial year:', error);
      throw error;
    }
  },
};

export default ProfileService;